<template>
    <div class="address-check">
        <addressCheckForm />
        <addressCheckHistory />
        <addressCheckModal />
    </div>
</template>

<script>
import addressCheckForm from './addressCheckForm.vue'
import addressCheckHistory from './addressCheckHistory.vue'
import addressCheckModal from './addressCheckModal.vue'
export default {
    components: {
        addressCheckForm,
        addressCheckHistory,
        addressCheckModal
    }
}
</script>